import ClipboardJS from 'clipboard'

export default function copyToClipboard() {
  new ClipboardJS('.copy-btn')
}
